const placeNormalTradeMapper = (response) => {
    if (response) {
        return {
            message: response.msg,
            orderID: response.oid,
            success: true,
        };
    }
    return {};
};
export default placeNormalTradeMapper;
